module.exports = __webpack_public_path__ + "550a732c12ef803370eb13c9e9cccc14.png";